import React from 'react';
import { View } from 'react-native';
import styled from '@emotion/native';
import Button from '@/shared/components/Button';
import { green, white } from '@/shared/styles/colors';

interface CompleteButtonsProps {
  onFirstButtonClick: () => void;
  onSecondButtonClick?: () => void;
  firstButtonText: string;
  secondButtonText?: string;
}

const CompleteButtons: React.FC<CompleteButtonsProps> = ({
  onFirstButtonClick,
  onSecondButtonClick,
  firstButtonText,
  secondButtonText,
}) => {
  return (
    <ButtonContainer>
      <ButtonWrapper>
        <Button
          variant="secondary"
          size="medium"
          text={firstButtonText}
          onPress={onFirstButtonClick}
        />
      </ButtonWrapper>
      {secondButtonText && onSecondButtonClick && (
        <ButtonWrapper>
          <Button
            variant="primary"
            size="medium"
            text={secondButtonText}
            onPress={onSecondButtonClick}
            customStyle={{ borderColor: white }}
          />
        </ButtonWrapper>
      )}
    </ButtonContainer>
  );
};

const ButtonContainer = styled(View)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  width: '100%',
  backgroundColor: green,
  alignItems: 'center',
});

const ButtonWrapper = styled(View)({
  width: '100%',
  marginBottom: 12,
  flex: 1,
  alignItems: 'center',
});

export default CompleteButtons;
